<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex justify-content-between align-items-center">
          <div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item class="bold"
                >Cấu hình chấm công</el-breadcrumb-item
              >
              <el-breadcrumb-item>Kết nối Agent</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div>
            <el-button
              type="primary"
              size="small"
              class="btn-default"
              @click="$router.push({ name: 'Admin-Timekeeping-TimekeepingConfig-AgentMonitor' })"
            >
              <i class="fas fa-desktop mr-1"></i> Giám sát & Điều khiển Agent
            </el-button>
          </div>
        </div>
        <div class="main-body mt-5">
          <div class="main-body-table">
            <div
              class="el-card is-always-shadow pt-3"
              v-if="mData.dataDefault.listFeature.includes('FT302')"
            >
              <el-form
                :model="mData.dataForm"
                :rules="mData.validForm"
                ref="myForm"
                label-position="left"
                @submit.native.prevent
                label-width="140px"
                style="margin-left: 30px"
              >
                <b-row>
                  <b-col :lg="mData.viewMode == 'create' ? 9 : 8" :md="mData.viewMode == 'create' ? 8 : 7">
                    <el-form-item label="Tên hiển thị" prop="name">
                      <el-input clearable v-model="mData.dataForm.name" @input="forceUpdateUI">
                      </el-input>
                    </el-form-item>
                  </b-col>
                  <b-col lg="auto" md="auto" sm="auto" class="mb-4">
                    <div class="text-center">
                      <el-button
                        v-if="mData.viewMode == 'create'"
                        @click="fn_addNewAgent('create')"
                        class="btn-default"
                        >Thêm mới Agent</el-button
                      >
                      <el-button
                        v-if="mData.viewMode == 'update'"
                        class="btn-default"
                        @click="fn_addNewAgent('update')"
                        >Cập nhật</el-button
                      >
                      <el-button
                        v-if="mData.viewMode == 'update'"
                        class="btn-back"
                        @click="fn_cancelUpdate('update')"
                        >Hủy cập nhật</el-button
                      >
                    </div>
                  </b-col>
                </b-row>
              </el-form>
            </div>
            <div class="list-agent mt-3">
              <el-table
                :data="mData.tableRules.data"
                border
                @selection-change="fn_tableSelectionChange"
                @sort-change="fn_tableSortChange"
                style="width: 100%"
                :default-sort="{
                  prop: mData.tableRules.defaultSort[0],
                  order: mData.tableRules.defaultSort[1]
                }"
              >
                <el-table-column
                  type="selection"
                  width="40"
                  v-if="mData.tableRules.allowSelect"
                ></el-table-column>
                <el-table-column prop="" label="STT" width="50">
                  <template slot-scope="scope">
                    <div class="text-center">
                      {{ mData.tableRules.offset + scope.$index + 1 }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="Tên hiển thị"
                  min-width="200"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="created_at"
                  label="Ngày tạo"
                  min-width="80"
                ></el-table-column>
                <el-table-column
                  prop="api_key"
                  label="API key"
                  min-width="300"
                ></el-table-column>
                <el-table-column
                  label="Thao tác"
                  width="160"
                  align="center"
                  v-if="
                    mData.dataDefault.listFeature.includes('FT308') ||
                      mData.dataDefault.listFeature.includes('FT307') ||
                      mData.dataDefault.listFeature.includes('FT304')
                  "
                >
                  <template slot-scope="scope">
                    <div class="d-flex justify-content-around">
                        <i class="isax-edit-2 icon icon-orange"
                        @click="fn_handle('update', scope.$index, scope.row)"
                        v-b-popover.hover.left="aLang.c_update"
                        v-if="mData.dataDefault.listFeature.includes('FT307')"
                        ></i>
                        <i class="isax-trash icon icon-red"
                          @click="fn_handle('delete', scope.$index, scope.row)"
                          v-b-popover.hover.left="aLang.c_delete"
                          v-if="mData.dataDefault.listFeature.includes('FT308')"
                        ></i>
                      <i class="isax-note-2 icon icon-blue"
                        @click="fn_handle('manage', scope.$index, scope.row)"
                        v-b-popover.hover.left="aLang.c_manage"
                        v-if="mData.dataDefault.listFeature.includes('FT304')"
                      ></i>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="Đẩy thông tin nhân sự"
      :visible.sync="mData.dialogSettingAgent"
      width="30%"
    >
      <el-form
        ref="myForm"
        label-position="top"
        @submit.native.prevent
        label-width="135px"
      >
        <el-form-item label="">
          <el-radio-group class="ml-2" v-model="mData.dataDefault.resource">
            <b-row class="mb-3"
              ><el-radio label="1"
                >Tự động khi có thông tin mới</el-radio
              ></b-row
            >
            <!-- <b-row class="mb-3"
              ><el-radio label="2"
                >Theo giờ cấu hình từng Agent</el-radio
              ></b-row
            > -->
          </el-radio-group>
        </el-form-item>
        <div class="text-center mb-0">
          <!-- <el-button icon="el-icon-circle-plus-outline" type="primary" round
            >Lưu</el-button
          > -->
        </div>
      </el-form>
    </el-dialog>
    <!-- Dialog Warning when click delete -->
    <el-dialog
      :visible.sync="mData.dialogDeleteAgent"
      :show-close="false"
      :close-on-click-modal="false"
      width="400px"
      center
    >
      <div class="text-center">
        <img class="m-2" src="img/warning-agent.png" alt="Warning picture here!">
      </div>
        <div class="text-center font-lg bold-500 mt-2 mb-3">Bạn có chắc chắn muốn xóa bản ghi này không?</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mData.dialogDeleteAgent = false" class="btn-back">Hủy</el-button>
        <el-button @click="fn_delete(mData.idRecordDelete)" class="btn-default">Đồng ý</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../../../service/LanguageService";
import MethodService from "../../../../../service/MethodService";
import AgentModel from "./AgentModel";
import AgentApi from "../../../../../moduleApi/AgentApi";
import { data } from "jquery";
export default {
  data() {
    return {
      aLang: LanguageService.lang,
      mData: {
        data: [],
        viewMode: "create",
        moduleName: "AgentConnection", //requied
        dialogSettingAgent: false,
        dialogDeleteAgent: false,
        idRecordDelete: false,
        dataForm: MethodService.copyObject(AgentModel.dataForm),
        tableRules: MethodService.copyObject(AgentModel.tableRules),
        validForm: AgentModel.validForm,
        dataDefault: {
          resource: "1",
          listFeature: MethodService.getListFeatures()
        }
      }
    };
  },

  methods: {
    async fn_initDataDefault() {
      const agentApiRes = await AgentApi.list();
      if (agentApiRes.result) {
        this.mData.tableRules.data = await this.fn_changeData(agentApiRes.result);
      }
    },

    fn_changeData(resData) {
      resData.forEach(item => {
        if (item.created_at) {
          item.created_at = MethodService.formatDate(item.created_at, "date");
        }
      });
      return resData;
    },

    fn_addNewAgent(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          try {
            let dataAgentDetail = this.mData.dataForm;
            if (type == "create") {
              let data = { name: this.mData.dataForm.name.trim() };
              await AgentApi.create(data);
              await this.fn_initDataDefault();
            } else if (type == "update") {
              dataAgentDetail.name = this.mData.dataForm.name.trim();
              await AgentApi.update(dataAgentDetail);
              await this.fn_initDataDefault();
            }
            await this.fn_resetForm();
            this.mData.viewMode = "create";
            MethodService.stopLadda();
          } catch (error) {
            // console.log("error", error);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_cancelUpdate() {
      this.fn_resetForm();
      this.mData.viewMode = "create";
      MethodService.stopLadda();
    },

    //event table
    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initDataDefault();
    },

    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },

    fn_handle(type, scope, row) {
      if (type == "update") {
        this.fn_resetForm();
        this.mData.viewMode = "update";
        this.fn_getDataById(row.id);
      }
      if (type == "delete") {
        this.mData.idRecordDelete = row.id;
        this.mData.dialogDeleteAgent = true;
      }
      if (type == "manage") {
        this.mData.tableRules.data.api_key = row.id;
        this.$router.push({
          name: "Admin-Timekeeping-TimekeepingConfig-AgentConnectionManagement",
          params: { id: row.id }
        });
      }
    },

    async fn_getDataById(id) {
      let agentApiRes = await AgentApi.findById(id);
      if (agentApiRes.result) {
        this.mData.dataForm = agentApiRes.result;
      }
    },

    async fn_delete(id) {
      await AgentApi.delete(id);
      await this.fn_initDataDefault();
      if (this.mData.dataForm.name) {
        this.fn_resetForm();
      }
      this.mData.idRecordDelete = "";
      this.mData.dialogDeleteAgent = false;
    },

    forceUpdateUI() {
      this.$forceUpdate();
    }
  },

  created() {
    this.fn_initDataDefault();
  },
};
</script>

<style scoped>
.icon {
  cursor: pointer;
}
.icon-orange {
  color: var(--orange);
}
.icon-red {
  color: var(--red);
}
.icon-blue {
  color: var(--blue);
}
::v-deep .el-dialog__body {
  padding: 0px !important;
}
::v-deep .el-dialog__header {
  background-color: #fff !important;
  border-bottom: 1px solid #fff !important;
}
</style>
